<template>
  <!--
    	作者：kmdshop
    	时间：2019-10-25
    	描述：组件-选择标签
    -->
  <el-dialog title="选择出货到哪" :visible.sync="dialogVisible" @close="dialogFormVisible" 
  :close-on-click-modal="false" :close-on-press-escape="false" width="900px"
  :append-to-body="true"
  >
    <div class="common-seach-wrap">
      <el-form :inline="true" size="small" :model="formInline" class="demo-form-inline">
        <el-form-item label="出货到哪">
          <el-input placeholder="请输入出货到哪名称" v-model="formInline.name">
            
          </el-input>
        </el-form-item>
        <el-form-item label="关联用户">
          <el-input placeholder="请输入关联用户会员ID" v-model="formInline.user_id">
          </el-input>
        </el-form-item>
        <el-form-item label="出货到哪等级">
          <el-select v-model="formInline.kmd_grade_id" clearable  placeholder="-请选择等级-">
            <el-option v-for="item in gradeList" :value="item.kmd_grade_id" :key="item.kmd_grade_id" :label="item.name" ></el-option>
          </el-select>
        </el-form-item>
         <el-form-item><el-button icon="el-icon-search" @click="getData">查询</el-button></el-form-item>
         
      </el-form>
    </div>

    <!--内容-->
    <div class="product-content">
      <div class="table-wrap">
        <el-table size="small" :data="tableData" border style="width: 100%" highlight-current-row v-loading="loading" @selection-change="tableCurrentChange">

          <el-table-column prop="supply_id" label="出货到哪ID"></el-table-column>
            <el-table-column prop="name" label="出货到哪名称"></el-table-column>
            <el-table-column prop="user_id" label="关联用户ID" width="150"></el-table-column>
            <el-table-column label="账号" width="150" >
              <template slot-scope="scope">
              <span v-if="scope.row.shop_user">{{scope.row.shop_user.user_name}}</span>
            </template>	
            </el-table-column>
            <el-table-column label="出货到哪等级">
              <template slot-scope="scope">
              <span>{{scope.row.kmd_grade.name}}</span>
            </template>	
            </el-table-column>
            <el-table-column width="80" label="单选" >
            <template slot-scope="scope">
              <el-button size="mini" @click="SingleFunc(scope.row)">选择</el-button>
            </template>
          </el-table-column>

        </el-table>
      </div>

      <!--分页-->
      <div class="pagination">
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" background :current-page="curPage" :page-sizes="[2, 10, 20, 50, 100]" :page-size="pageSize" layout="total, prev, pager, next, jumper" :total="totalDataNumber"></el-pagination>
      </div>
    </div>

    <div slot="footer" class="dialog-footer">
      <el-button size="small" @click="dialogVisible=false">取 消</el-button>
      <el-button size="small" type="primary" @click="addClerk">确 定</el-button>
    </div>
  </el-dialog>
</template>

<script>
import SupplyApi from '@/api/supply.js';

export default {
  data() {
    return {
      /*是否加载完成*/
      loading: true,
      /*当前是第几页*/
      curPage: 1,
      /*一页多少条*/
      pageSize: 10,
      /*一共多少条数据*/
      totalDataNumber: 0,
      formInline: {
        name:'',
        user_id:'',
      },
      //标签列表
      tableData: [],
      gradeList: [],
      multipleSelection: [],
      /*左边长度*/
      formLabelWidth: '120px',
      /*是否显示*/
      dialogVisible: false,
      /*结果类别*/
      type: 'error',
      /*传出去的参数*/
      params: null
    };
  },
  props: ['isproduct'],
  watch: {
    isproduct: function (n, o) {
      if (n != o) {
        if (n) {
          this.dialogVisible = n;
          this.type = 'error';
          this.params = null;
          this.getData();
        }
      }
    }
  },
  created() {

  },
  methods: {

    /*是否可以勾选*/
    selectableFunc(e) {
      if (typeof e.noChoose !== 'boolean') {
        return true;
      }
      return e.noChoose;
    },

    /*选择第几页*/
    handleCurrentChange(val) {
      this.curPage = val;
      this.getData();
    },

    /*每页多少条*/
    handleSizeChange(val) {
      this.curPage = 1;
      this.pageSize = val;
      this.getData();
    },

    /*获取标签列表*/
    getData() {
      let self = this;
      let params = self.formInline;
      params.page = self.curPage;
    
      params.list_rows = self.pageSize;
      SupplyApi.supplyListsx(params, true)
        .then(res => {
          if (res.code == 1) {
            self.loading = false;
            self.tableData = res.data.list.data;
            self.totalDataNumber = res.data.list.total;
            self.gradeList = res.data.gradeList;
          }
        })
        .catch(error => {});
    },

    /*单选*/
    SingleFunc(row) {
      this.multipleSelection = [row];
      this.addClerk();
    },

    //点击确定
    addClerk() {
      let self = this;
      let params = null;
      let type = 'success';
      if (self.multipleSelection.length < 1) {
        self.$message({
          message: '请至少选择一个出货到哪！',
          type: 'error'
        });
        return;
      }

      params = self.multipleSelection;
      self.params = params;
      self.type = 'success';
      self.dialogVisible = false;
    },

    /*关闭弹窗*/
    dialogFormVisible() {
      this.$emit('closeDialog', {
        type: this.type,
        openDialog: false,
        params: this.params
      });
    },

    /*监听复选按钮选中事件*/
    tableCurrentChange(val) {
      console.log(val)
      this.multipleSelection = val;
    }
  }
};
</script>

<style>
.no-list .el-checkbox {
  display: none;
}
</style>



// WEBPACK FOOTER //
// src/components/supply/Supplyx.vue